import React from 'react'
import { cdnImg } from 'meinian-package/src/utils/image'
import isIPad, { isIphone } from 'meinian-package/src/common/isIPad'
import { OFFICIAL_INSPIRATION_TYPE } from '../../officialInspiration'
import styles from './index.module.less'
import { ShareType } from './shareType'

export default (props) => {
  const {
    columnWidth,
    itemData,
  } = props
  return <div
    style={{ width: columnWidth, height: columnWidth + 78 }}
    className={styles['intellect-card-inspiration']}
    onClick={() => {
      if (itemData.type === OFFICIAL_INSPIRATION_TYPE.EXCLUSIVE) {
        window.open(`/meinian/home/coll/exclusive-detail?id=${itemData.blogId}&name=${itemData.name}`)
        return
      }
      if (isIPad || !isIphone) {
        window.open(`/meinian/home/coll/detail/${itemData.shareUrl}?shareUrl=${itemData.shareUrl}&shareType=${ShareType.OFFICIAL}`)
      } else {
        window.open(`/visitor/insColl/detail/h5?shareUrl=${itemData.shareUrl}&shareType=${ShareType.OFFICIAL}`)
      }
    }}
  >
    <img
      loading="lazy"
      src={cdnImg(itemData.coverImgUrl || itemData.lastBlogList?.[0]?.mainUrl, 500)}
      style={{ width: '100%', borderRadius: '9px', height: columnWidth, objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }}
    />
    <div style={{ padding: '0 8px' }}>
      <div
        style={{ width: columnWidth - 32 }}
        className="item-title text-overflow"
      >{itemData.name}</div>
      <div className="item-brief">
        <span>款式 <i>{itemData.blogNum}</i></span>
      </div>
    </div>
  </div>
}
